import React, { FunctionComponent } from 'react';
import { Box, Typography } from '@material-ui/core';
import specificationsStyles from './specificationsStyles';
import Translation from '../../../../../../../common/components/translation/Translation';

export interface ISpecificationsProps {
  engineTitle: string;
  transmissionTitle: string;
}

const Specifications: FunctionComponent<ISpecificationsProps> = ({ engineTitle, transmissionTitle }) => {
  const styles = specificationsStyles();

  return (
    <Box className={styles.container} data-test="customise:specificationsContent">
      <Typography className={styles.title} data-test="customise:specificationsTitle">
        <Translation id="spc.customise.specifications.title" />
      </Typography>
      <Typography
        component="p"
        variant="body1"
        className={styles.description}
        data-test="customise:specificationsEngine"
      >
        {engineTitle}
      </Typography>
      <Typography
        component="p"
        variant="body1"
        className={styles.description}
        data-test="customise:specificationsTransmission"
      >
        {transmissionTitle}
      </Typography>
    </Box>
  );
};

export default Specifications;
